import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, apiErr } from "../api/client";
import { Sound } from "../game/audio";

const PlayerContext = createContext(null);
export const usePlayer = () => useContext(PlayerContext);

export function PlayerProvider({ children }) {
  const [profile, setProfile] = useState(null); // null=loading
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  const boot = useCallback(async () => {
    // Handle Emergent Google OAuth return: session_id in URL fragment (process first)
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.slice(1)).get("session_id");
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      if (sid) {
        try {
          const { data } = await api.googleSession(sid);
          setToken(data.token);
          setProfile(data.user);
          setReady(true);
          return;
        } catch (e) { console.warn("Google session exchange failed", e); }
      }
    }
    try {
      const { data } = await api.me();
      setProfile(data.user);
    } catch {
      // No session -> create guest automatically (instant play)
      try {
        const { data } = await api.guest();
        setToken(data.token);
        setProfile(data.user);
      } catch (e) {
        setError(apiErr(e, "Could not connect to server."));
      }
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { boot(); }, [boot]);

  // sync sound prefs
  useEffect(() => {
    if (profile?.settings) {
      Sound.setEnabled(profile.settings.sound !== false);
    }
  }, [profile?.settings?.sound]);

  const applyUser = (u) => u && setProfile(u);

  const registerAccount = async (body) => {
    const { data } = await api.register(body);
    setToken(data.token);
    setProfile(data.user);
    return data;
  };
  const loginAccount = async (body) => {
    const { data } = await api.login(body);
    setToken(data.token);
    setProfile(data.user);
    return data;
  };
  const logout = async () => {
    try { await api.logout(); } catch (e) { console.warn("Logout request failed", e); }
    setToken(null);
    setProfile(null);
    setReady(false);
    boot();
  };

  return (
    <PlayerContext.Provider value={{ profile, ready, error, applyUser, registerAccount, loginAccount, logout, refresh: boot }}>
      {children}
    </PlayerContext.Provider>
  );
}
